import { useLocation } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';

const getPathTypes = (pathname, forceCreate, forceEdit) => {
  const isEditing = forceEdit || pathname.indexOf('edit') !== -1;
  const isCreating = forceCreate || pathname.indexOf('create') !== -1;
  const viewMode = !(isEditing || isCreating);

  return {
    isEditing,
    isCreating,
    viewMode
  };
};

export const useFormTitle = (forceCreate, forceEdit) => {
  const { pathname } = useLocation();
  const [{ isEditing, isCreating, viewMode, backToView }, setState] = useState(getPathTypes(pathname, forceCreate, forceEdit));

  const toggleView = useCallback(() => {
    setState(prevState => {
      if (prevState.isEditing) {
        return { isEditing: false, viewMode: true };
      } else
        return { isEditing: true, viewMode: false, backToView: true };
    });
  }, []);

  useEffect(() => {
    setState(getPathTypes(pathname, forceCreate, forceEdit));
  }, [pathname, forceCreate, forceEdit]);

  let title = isCreating || forceCreate ? 'create' : 'details';
  if (isEditing)
    title = 'edit';
  return {
    title,
    isEditing,
    isCreating,
    pathname,
    viewMode,
    toggleView,
    backToView: backToView && !forceCreate
  };
};
